import {z} from "zod/v4-mini"
import {graphNode} from "@cm/graph-v3"
import {externalId} from "#template/nodes/validation"
import type {TemplateInstance} from "#template/nodes/object/template-instance"

export const outputNodeParameters = () =>
    z.object({
        name: z.string(),
        template: graphNode<TemplateInstance>("TemplateInstance"),
        outputId: externalId,
    })
